import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  getCourseList,
  getExam
} from "../../api/service.js"
import {
  pUrl
} from "@/api/baseURL.js";

let that;
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      contentHeight: {
        height: ''
      },
      radio: [],
      examObj: {},
      oldExamObj: {},
      examDetail: {},
      answerSheetList: [],
      checkedCities: [],
      keepTime: "",
      int: {},
      userAnswerList: [],
      totalNum: 0,
      activeName: "",
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
      isJx: false,

    }
  },
  created() {
    that = this;
    that.contentHeight.height = window.innerHeight - 250 + 'px';
    that.examObj = JSON.parse(sessionStorage.getItem("examObj"));
    that.getDetail()
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
    // var pUrl=window.location.href;
    //  // 是否是江西代理商访问
    //      if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //      console.log(1111,this.isJx)
    //      this.isJx=true;
    //  }
  },
  // mounted() {
  //   var publicCourse = document.getElementsByClassName("practiceResultDetail")
  //   publicCourse.style.minHeight = document.body.scrollHeight - 90 - 257 + "px"
  // },
  methods: {
    getDetail() { //重新开始
      that.answerSheetList = [];
      var number = 0;
      that.radio = [];
      let url = "exercise/exerciseRecordResult";
      let data = {
        exerciseRecordId: this.$route.query.exerciseId
      };
      getExam(url, data).then(res => {
        if (res.success) {
          var totalScore = 0;
          var totalNum = 0; //总题数
          var isRightTotalNum = 0; //答对题数

          that.examObj = res.data;
          var list = res.data;
          list.paperEntity.paperAreaList.forEach((obj) => {
            var aObj = {
              titleName: "",
              list: []
            };
            obj.questionList.forEach((questionObj) => {
              console.log('questionObj', questionObj)
              totalScore = totalScore + questionObj.score;
              totalNum = totalNum + 1;
              if (questionObj.isRight) {
                isRightTotalNum = isRightTotalNum + 1;
              } else {
                number = number + 1;
                questionObj.number = number;
                var answerN = "";
                questionObj.questionAnswers.forEach((answersObj, index) => {
                  switch (index) {
                    case 0:
                      answersObj.nName = "A";
                      break;
                    case 1:
                      answersObj.nName = "B";
                      break;
                    case 2:
                      answersObj.nName = "C";
                      break;
                    case 3:
                      answersObj.nName = "D";
                      break;
                    case 4:
                      answersObj.nName = "E";
                      break;
                    case 5:
                      answersObj.nName = "F";
                      break;
                    case 6:
                      answersObj.nName = "G";
                      break;
                  }
                  if (answersObj.isRight) {
                    if (answerN != "") {
                      answerN = answerN + "," + answersObj.nName
                    } else {
                      answerN = answerN + answersObj.nName
                    }

                  }
                });
                questionObj.rightAnswerName = answerN;
                aObj.titleName = obj.paperAreaName;
                aObj.list.push(questionObj);
              }

            });
            that.answerSheetList.push(aObj)
          });
          that.examObj.totalScore = totalScore;
          that.examObj.totalNum = totalNum;
          that.examObj.isRightTotalNum = isRightTotalNum;
          that.examDetail = that.answerSheetList[0].list[0] ? that.answerSheetList[0].list[0] : that.answerSheetList[1].list[0];
          that.totalNum = that.answerSheetList[that.answerSheetList.length - 1].list[that.answerSheetList[that.answerSheetList.length - 1].list.length - 1].number;
          that.radio.push(parseInt(that.examDetail.answerId));
        } else {
          this.$message.error(res.message)
        }
      })



    },
    clickAnswerSheet(detail) { //点击答题卡
      that.examDetail = detail;
      that.checkedCities = [];
      that.radio = [];
      var list = [];
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }

      } else {
        that.radio.push(parseInt(detail.answerId));
      }
      if (detail.answerId != undefined) {
        that.examDetail.isDisabled = true;
      }
    },
    onTopic() { //上一题
      that.checkedCities = [];
      that.radio = [];
      for (var c = 0; c < that.answerSheetList.length; c++) {
        for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
          if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
            if (i != 0) {
              that.examDetail = that.answerSheetList[c].list[i - 1];
            } else {
              that.examDetail = that.answerSheetList[c - 1].list[that.answerSheetList[c - 1].list.length - 1];
            }

          }
        }
      }
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          var list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }
      } else {
        that.radio.push(parseInt(that.examDetail.answerId));
      }
    },
    nextQuestion() { //下一题
      that.checkedCities = [];
      var detail = {};
      that.radio = [];
      for (var c = 0; c < that.answerSheetList.length; c++) {
        for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
          if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
            if (i >= that.answerSheetList[c].list.length - 1) {
              detail = that.answerSheetList[c + 1].list[0];
            } else {
              detail = that.answerSheetList[c].list[i + 1];
            }

          }
        }
      }
      that.examDetail = detail;
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          var list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }
      } else {
        that.radio.push(parseInt(detail.answerId));
      }
    },

    //返回上一页
    goBack() {
      if (this.$route.query.exerciseId != "") {
        this.$router.push({
          path: "/studyCentre"
        });
      } else {
        this.$router.push({
          path: "/examList"
        });
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/mistakesDetail/mistakesDetail.js